// router.js
import Vue from 'vue';
import VueRouter from 'vue-router';
 
Vue.use(VueRouter);
 
const routes = [
  {
    path: '/ydy',
    name: 'ydy',
    component: () => import('@/views/ydy.vue')
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/index.vue')
  },
  {
    path: '/xxgs',
    name: 'xxgs',
    component: () => import('@/views/xxgs.vue')
  },
  {
    path: '/xyfw',
    name: 'xyfw',
    component: () => import('@/views/xyfw.vue')
  },
  {
    path: '/zcfg',
    name: 'zcfg',
    component: () => import('@/views/zcfg.vue')
  },
  {
    path: '/xyzl',
    name: 'xyzl',
    component: () => import('@/views/xyzl.vue')
  },
  {
    path: '/grxy',
    name: 'grxy',
    component: () => import('@/views/grxy.vue')
  },
  {
    path: '/hyxy',
    name: 'hyxy',
    component: () => import('@/views/hyxy.vue')
  },
  {
    path: '/xyttInfo',
    name: 'xyttInfo',
    component: () => import('@/views/xyttInfo.vue')
  },
  {
    path: '/xzxk',
    name: 'xzxk',
    component: () => import('@/views/xzxk.vue')
  },
   
  {
    path: '/zdrq',
    name: 'zdrq',
    component: () => import('@/views/zdrq.vue')
  },
  {
    path: '/xyxx',
    name: 'xyxx',
    component: () => import('@/views/xyxx.vue')
  },
  {
    path: '/xydt',
    name: 'xydt',
    component: () => import('@/views/xydt.vue')
  },
  {
    path: '/xyxxInfo',
    name: 'xyxxInfo',
    component: () => import('@/views/xyxxInfo.vue')
  },
   
 
];
 const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
 
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});
 
export default router;